import { all } from 'redux-saga/effects';

const reduxModalsSagas = function* root() {
  yield all([]);
};
export { reduxModalsSagas };
